import { set, toggle } from '@/utils/vuex'

export default {
  setUser: set('user'),
  setDrawer: set('drawer'),
  setImage: set('image'),
  setDark: set('dark'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  toggleDark: (state) => {
    state.dark = !state.dark
    localStorage.setItem('dark', state.dark)
  }
}
